// extracted by mini-css-extract-plugin
export default {"qr":"attendance-qr_qr__RvaBz","noSelection":"attendance-qr_noSelection__W9tKY"};